import { SALES_CHECK_IN_APPLICATION_NAME } from '@makemydeal/dr-shared-types';

export const APP_NAME = SALES_CHECK_IN_APPLICATION_NAME;
export const APP_SCOPE = 'deal-mgmt.sales-checkin.app.access';

// Fallback Pendo account id used when the authenticated user has no
// accountId; must match the value passed to `window.pendo.initialize`.
export const DEFAULT_PENDO_ACCOUNT_ID = 'dc_salescheckin';

export const CLIENT_ID = '0oa1ha14dc27kim73358';
export const NON_PROD_CLIENT_ID = '0oa1ha138ey16JQy7358';

export const OKTA_CONFIG_ID_PROD = 'cmd_prod_bridge_signin_spa_salescheckin';
export const OKTA_CONFIG_ID_NON_PROD = 'cmd_qa_bridge_signin_spa_salescheckin';

export const ROOT_ROUTE = '';

export const SAVE_PARTICIPANTS_ENDPOINT_PATTERN = /\/deal\/[^/]+\/participants$/;
